<template>
  <div class="flex items-center mt-4 pt-4 border-t border-black/6 max-md:flex-wrap max-md:gap-3">
    <div class="flex items-center gap-2 flex-1 min-w-0 max-md:flex-[0_0_calc(50%-6px)]">
      <span class="w-2 h-2 rounded-full shrink-0" :class="paymentDotClass"></span>
      <span class="text-[11px] font-semibold uppercase tracking-wide text-muted shrink-0">Payment</span>
      <span class="text-[13px] font-semibold text-ink whitespace-nowrap overflow-hidden text-ellipsis">{{ paymentStatus.text }}</span>
    </div>
    <div class="w-px h-6 bg-black/6 shrink-0 mx-3 max-md:hidden"></div>
    <div class="flex items-center gap-2 flex-1 min-w-0 max-md:flex-[0_0_calc(50%-6px)]">
      <span class="w-2 h-2 rounded-full shrink-0" :class="deadlineDotClass"></span>
      <span class="text-[11px] font-semibold uppercase tracking-wide text-muted shrink-0">Deadline</span>
      <span class="text-[13px] font-semibold text-ink whitespace-nowrap overflow-hidden text-ellipsis">{{ deadlineInfo.text }}</span>
    </div>
    <div class="w-px h-6 bg-black/6 shrink-0 mx-3 max-md:hidden"></div>
    <div class="flex items-center gap-2 flex-1 min-w-0 max-md:flex-[0_0_calc(50%-6px)]">
      <span class="w-2 h-2 rounded-full shrink-0" :class="overdueCount > 0 ? 'bg-[#e53935]' : 'bg-[#c0bcc4]'"></span>
      <span class="text-[11px] font-semibold uppercase tracking-wide text-muted shrink-0">Overdue</span>
      <span class="text-[13px] font-semibold text-ink whitespace-nowrap overflow-hidden text-ellipsis">{{ overdueCount }}</span>
    </div>
    <div class="w-px h-6 bg-black/6 shrink-0 mx-3 max-md:hidden"></div>
    <div class="flex items-center gap-2 flex-1 min-w-0 max-md:flex-[0_0_calc(50%-6px)]">
      <span class="w-2 h-2 rounded-full shrink-0" :class="pendingCount > 0 ? 'bg-[#f57c00]' : 'bg-[#c0bcc4]'"></span>
      <span class="text-[11px] font-semibold uppercase tracking-wide text-muted shrink-0">Pending</span>
      <span class="text-[13px] font-semibold text-ink whitespace-nowrap overflow-hidden text-ellipsis">{{ pendingCount }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'case-pulse',
  props: {
    applicant: {
      type: Object,
      required: true
    }
  },
  computed: {
    paymentStatus () {
      if (this.applicant.paid) {
        return { text: 'Received' }
      }
      return { text: 'Pending' }
    },
    paymentDotClass () {
      return this.applicant.paid ? 'bg-[#2d7a0e]' : 'bg-[#c0bcc4]'
    },
    deadlineInfo () {
      if (!this.applicant.deadline) {
        return { text: 'No deadline' }
      }
      const deadline = this.normalizeDate(this.applicant.deadline)
      const days = dayjs(deadline).diff(dayjs(), 'day')
      if (days < 0) {
        return { text: Math.abs(days) + 'd overdue' }
      }
      if (days === 0) {
        return { text: 'Today' }
      }
      if (days <= 14) {
        return { text: days + 'd left' }
      }
      return { text: days + 'd left' }
    },
    deadlineDotClass () {
      if (!this.applicant.deadline) return 'bg-[#c0bcc4]'
      const deadline = this.normalizeDate(this.applicant.deadline)
      const days = dayjs(deadline).diff(dayjs(), 'day')
      if (days < 0 || days === 0) return 'bg-[#e53935]'
      if (days <= 14) return 'bg-[#f57c00]'
      return 'bg-[#c0bcc4]'
    },
    overdueCount () {
      const dates = this.applicant.keyDates || []
      return dates.filter(d => {
        if (d.completed) return false
        if (!d.date) return false
        return dayjs(d.date).isBefore(dayjs(), 'day')
      }).length
    },
    pendingCount () {
      const reqs = this.applicant.requirements || []
      const activeStatuses = ['collecting', 'inProgress', 'toCheck']
      return reqs.filter(r => activeStatuses.includes(r.status)).length
    }
  },
  methods: {
    normalizeDate (val) {
      if (!val) return null
      if (typeof val.toDate === 'function') return val.toDate().toISOString()
      if (val.seconds) return new Date(val.seconds * 1000).toISOString()
      return val
    }
  }
}
</script>
